'use strict';

var _ = require('underscore');
var $ = require('jquery');
var Radio = require('backbone.radio');

require('intl-tel-input/build/js/intlTelInput.min');
require('intl-tel-input/build/js/utils');

var polyglot = require('../../utilities/polyglot').default;
var urls = require('../../utilities/urls').default;

var FormView = require('../form').default;
var AttendeeView = require('./attendee').default;
var ResponsesView = require('../responses/responses').default;

var Tracker = require('../../../analytics/events').default;

export default FormView.extend({

  className: 'form details-form',
  template: require('./templates/form.hbs'),
  regions: {
    questions: '.l-details-form-questions',
  },
  events: {
    'keyup #first-name,#last-name,#email,#cell-phone,#home-phone,#work-phone,#notes,#appt-address,#appt-city': 'onKeyUp',
    'change #prov-state': 'onKeyUp',
    'change #country': 'onCountryChange',
    'keyup #zip-postal,#address,#city': 'onAddressKeyUp',
    'change #receive_sms': 'onReceiveSms',
  },
  triggers: {
    'click .details-form-summary-link a': 'click:summary',
  },
  ui: {
    first_name: '#first-name',
    last_name: '#last-name',
    email: '#email',
    address: '#address',
    city: '#city',
    prov_state: '#prov-state',
    zip_postal: '#zip-postal',
    country: '#country',
    cell_phone: '#cell-phone',
    home_phone: '#home-phone',
    work_phone: '#work-phone',
    notes: '#notes',
    appt_address: '#appt-address',
    appt_city: '#appt-city',
    receive_sms: '#receive_sms',
    attendees_list: '#attendees-list',
  },
  masks: {},

  initialize: function (options) {
    this.listenTo(Radio.channel('steps'), 'click:next', this.onNext);
    this.listenTo(Radio.channel('steps'), 'click:book', this.onSubmit);

    this.responses = this.model.responses;
    this.detailsView = options.parentView;
  },

  showFields: function () {
    this.getRegion('questions').show(new ResponsesView({collection: this.responses, model: this.model}));
  },

  serializeData: function () {
    var json = this.model.toJSON();

    json = this.setClientFieldConditionals(json);

    json.isAway = this.model.isAway();
    json.isEnd = !window.SETTINGS.credit_card_capture;
    json.showMultipleAttendees = window.SETTINGS.allow_multiple_attendees;
    json.additionalAttendeePreamble = window.SETTINGS.additional_attendee_preamble;

    json.disableAddAttendee = false;
    const additionalAttendees = this.model.get('additionalClients');
    if (this.model.isGroup()) {
      const limit = this.model.get('attendee_limit');
      const existingAttendeesCount = this.model.get('attendee_count');

      if (limit) {
        const maxAttendeesToAdd = additionalAttendees
                                  ? limit - existingAttendeesCount - additionalAttendees.length
                                  : limit - existingAttendeesCount;
        json.disableAddAttendee = maxAttendeesToAdd <= 1;
      }
    } else {
      const limit = window.SETTINGS.multiple_attendees_limit;

      if (limit && additionalAttendees && additionalAttendees.length >= limit) {
        json.disableAddAttendee = true;
      }
    }

    if (this.responses) {
      json.responses = this.responses.toJSON();
    }

    json.remoteMessage = this.getRemoteMessage();
    json.bookingStatement = window.SETTINGS.booking_statement || '';

    return json;
  },

  renderIntlTelInputs: function () {
    var inputs = [this.ui.cell_phone, this.ui.home_phone, this.ui.work_phone];
    var i = 0;

    for (i; i < inputs.length; i++) {
      var input = inputs[i];

      if (input.length > 0) {
        input.intlTelInput({
          nationalMode: true,
          initialCountry: 'auto',
          geoIpLookup: function (callback) {
            $.get('https://ipinfo.io', function() {}, 'jsonp').always(function(resp) {
              var countryCode = (resp && resp.country) ? resp.country : 'US';
              callback(countryCode);
            });
          },
        });
      }
    }
  },

  getRemoteMessage: function () {
    if (!this.model.isRemote()) {
      return null;
    }

    if (!window.SETTINGS.show_staff_picker) {
      return polyglot.t('details.remote_message_without_staff');
    }

    var staff = this.model.getStaff();
    if (staff) {
      return polyglot.t('details.remote_message', {name: staff.get('full_name')});
    }

    return null;
  },

  focus: function () {
    this.ui.first_name.focus();
  },

  updateModel: function () {
    const bookingShortcut = urls.hasAllParams(['request_id', 'start'])
      ? null
      : urls.getBookingShortcut(['request_id', 'start']);

    var client = {
      id: null,
      first_name: this.ui.first_name.val(),
      last_name: this.ui.last_name.val(),
      email: this.ui.email.val(),
      lang: !!$('html').attr('lang') ? $('html').attr('lang') : 'en',
      receive_sms: window.SETTINGS.auto_sms_opt_in || this.ui.receive_sms.prop('checked'),
      appointmentclient: {
        booking_shortcut: bookingShortcut,
      },
    };

    if (this.model.showHomePhone()) {
      client.phone = this.ui.home_phone.intlTelInput('getNumber');
    }

    if (this.model.showMobilePhone()) {
      client.cell_phone = this.ui.cell_phone.intlTelInput('getNumber');
    }

    if (this.model.showWorkPhone()) {
      client.work_phone = this.ui.work_phone.intlTelInput('getNumber');
    }

    var notes = '';

    if (this.model.showNotes()) {
      notes = this.ui.notes.val();
      client.appointmentclient.notes = notes;
    }

    if (this.model.isAway()) {
      client.appt_address = this.ui.appt_address.val();
      client.appt_city = this.ui.appt_city.val();
    }

    if (this.model.showLocationInformation()) {
      client.address = this.ui.address.val();
      client.city = this.ui.city.val();
      client.zip_postal = this.ui.zip_postal.val();
      client.country = this.ui.country.val();
      client.prov_state = this.ui.prov_state.val();
    }

    this.model.set('client', [client]);
  },

  resetProvinceState: function () {
    this.clearProvinceStateOptions();
    if (this.ui.country.val() == 'US') {
      this.addStateOptions();
    }
    else if (this.ui.country.val() == 'CA') {
      this.addProvinceOptions();
    }
  },

  clearProvinceStateOptions: function () {
    this.ui.prov_state.html('');
    this.ui.prov_state.prop('disabled', true);
  },

  addStateOptions: function () {
    var self = this;
    var client = this.model.get('client');
    _.each(window.STATES, function (value, key) {
      self.ui.prov_state.append(self.addSelectOption(key, value, client[0].prov_state));
    });
    this.ui.prov_state.prop('disabled', false);
  },

  addProvinceOptions: function () {
    var self = this;
    var client = this.model.get('client');

    _.each(window.PROVINCES, function (value, key) {
      self.ui.prov_state.append(self.addSelectOption(key, value, client[0].prov_state));
    });
    this.ui.prov_state.prop('disabled', false);
  },

  addSelectOption: function (key, value, selectedVal) {
    var selected = selectedVal == key ? 'selected' : '';
    return "<option value='" + key + "' " + selected + ">" + value + "</option>";
  },

  initializeCountrySelect: function () {
    var self = this;
    var client = this.model.get('client');

    _.each(window.COUNTRIES, function (value, key) {
      self.ui.country.append(self.addSelectOption(key, value, client[0].country));
    });

    if (client[0].country == 'CA') {
      this.addProvinceOptions();
    }
    else if (client[0].country == 'US') {
      this.addStateOptions();
    }
    else {
      this.clearProvinceStateOptions();
    }
  },

  initializeAttendeesList: function () {
    const clients = this.model.get('additionalClients');

    if (!clients) {
      return;
    }

    clients.each((client) => {
      const attendeeView = new AttendeeView({
        client,
        clients,
        appointment: this.model,
      });
      this.ui.attendees_list.append(attendeeView.render().el);
      this.detailsView.createAttendeeEditListener(attendeeView);
    });
  },

  setClientFieldConditionals: function (json) {
    json.showLocationInformation = this.model.showLocationInformation();
    json.isLocationInformationRequired = this.model.isLocationInformationRequired();
    json.showHomePhone = this.model.showHomePhone();
    json.showMobilePhone = this.model.showMobilePhone();
    json.isHomePhoneRequired = this.model.isHomePhoneRequired();
    json.isMobilePhoneRequired = this.model.isMobilePhoneRequired();
    json.showWorkPhone = this.model.showWorkPhone();
    json.isWorkPhoneRequired = this.model.isWorkPhoneRequired();
    json.showNotes = this.model.showNotes();
    json.isNotesRequired = this.model.isNotesRequired();
    json.showSmsBox = window.SETTINGS.auto_sms_opt_in ? false : this.model.isSmsEnabled();
    json.creditCardEnabled = this.model.isCreditCardEnabled();
    json.showHomeWorkPhones = this.model.showHomePhone() || this.model.showWorkPhone();

    return json;
  },

  autoFillAwayLocation: function () {
    if (this.model.isAway()) {
      this.ui.appt_address.val(this.ui.address.val());
      this.ui.appt_city.val(this.ui.city.val() + " " + this.ui.zip_postal.val());
    }
  },

  trackCheckbox: function (event) {
    if (event.target.checked) {
      Tracker.trackEvent('Opt-In SMS', 'click', 'Checked');
    } else {
      Tracker.trackEvent('Opt-In SMS', 'click', 'Unchecked');
    }
  },

  onReceiveSms: function (event) {
    this.trackCheckbox(event);
    this.onKeyUp();
  },

});
